import React from 'react'
import { Box } from '@mui/material'
import { TV_COLORS } from '../designSystem'

type NeonProgressProps = {
  value: number // 0-100
}

const NeonProgress = ({ value }: NeonProgressProps) => {
  const clamped = Math.max(0, Math.min(100, value))
  const segments = Array.from({ length: 10 }).map((_, index) => {
    const segmentValue = (index + 1) * 10
    return segmentValue <= clamped
  })

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(10, 1fr)',
        gap: 0.5,
        mb: 2,
      }}
    >
      {segments.map((filled, idx) => (
        <Box
          // eslint-disable-next-line react/no-array-index-key
          key={idx}
          sx={{
            height: 10,
            borderRadius: 999,
            background: filled
              ? `linear-gradient(120deg, ${TV_COLORS.yellow}, ${TV_COLORS.orange || '#FF9800'})`
              : 'rgba(255,255,255,0.1)',
            boxShadow: filled ? `0 0 12px rgba(255,214,0,0.6)` : 'none',
          }}
        />
      ))}
    </Box>
  )
}

export default NeonProgress
